import React from 'react';
import OtkOptionCatalogList from '../../../components/otk/OtkOptionCatalogList';

/** qlty022 — REMOTE_NON_PROGRESSIVE via shared OtkOptionCatalogList (no reorder) */
export default function MeasureComplexityList() {
  return <OtkOptionCatalogList resource="measure_complexities" />;
}
